import React, { useContext } from 'react';
import * as stylex from '@stylexjs/stylex';
import AuditLogIndex from "src/routes/app/audit-log/AuditLogIndex";
import PropertyIndex from "src/routes/app/property/PropertyIndex";
import { AuthContext } from "src/session/AuthProvider";
import { permissionUtil } from "src/session/permissionUtil";
import AnalyticsIndex from "src/routes/app/analytics/AnalyticsIndex";
import SidebarNav from "nood-comp/src/comp/ui/nav/SidebarNav";
export default function Application(props) {
  var _useContext;
  var _useContext$user = (_useContext = useContext(AuthContext)) === null || _useContext === void 0 ? void 0 : _useContext.user,
    permissions = _useContext$user.permissions;
  return /*#__PURE__*/React.createElement(SidebarNav, {
    navTitle: "Your Application",
    "default": "logs",
    navCaption: "View application activites, performance, and settings.",
    menu: [{
      id: "logs",
      title: "Logs",
      content: /*#__PURE__*/React.createElement(AuditLogIndex, null),
      icon: "terminal",
      show: permissionUtil.has({
        permissions: permissions,
        entities: ['audit-log', 'audit-logs']
      })
    }, {
      id: "prop",
      title: "Property",
      content: /*#__PURE__*/React.createElement(PropertyIndex, null),
      icon: "tag",
      show: permissionUtil.has({
        permissions: permissions,
        entities: ['property', 'properties']
      })
    }, {
      id: "analytics",
      title: "Analytics",
      content: /*#__PURE__*/React.createElement(AnalyticsIndex, null),
      icon: "bar-chart-2",
      show: permissionUtil.has({
        permissions: permissions,
        entities: ['property', 'properties']
      })
    }],
    queryStringFilter: "pg"
  })
  /*<>
    <SubMenuNavigator
      default={'logs'}
      header={
        <div style={{padding: `15px`}}>
          Your Application
        </div>
      }
      menuItems={[
        {
          id: `logs`, title: `Logs`, content: <AuditLogIndex/>, icon: `terminal`,
          show: permissionUtil.has({permissions, entities: ['audit-log', 'audit-logs']})
        },
        {
          id: `prop`, title: `Property`, content: <PropertyIndex/>, icon: `tag`,
          show: permissionUtil.has({permissions, entities: ['property', 'properties']})
        },
        {
          id: `analytics`, title: `Analytics`, content: <AnalyticsIndex/>, icon: `bar-chart-2`,
          show: permissionUtil.has({permissions, entities: ['property', 'properties']})
        },
      ]}
      queryStringFilter={`pg`}/>
  </>*/;
}
Application.propTypes = {
  // proptypes
};

// @ts-ignore